import React, { useState } from 'react';
import { Collapse, Typography, Card, Space, Tag } from 'antd';
import {
  ThunderboltOutlined,
  DesktopOutlined,
  ApiOutlined,
  TeamOutlined
} from '@ant-design/icons';

// 导入子模块
import QuizManager from './QuizManager';
import QuizControl from './QuizControl';
import DesktopQuizManager from './DesktopQuizManager';

const { Title, Paragraph } = Typography;
const { Panel } = Collapse;

/**
 * 在线答题模块入口
 * 包含两个子模块：红外遥控器答题 和 桌面客户端在线答题
 */
const OnlineQuiz = () => {
  const [activeKey, setActiveKey] = useState(['desktop']); // 默认展开桌面客户端

  return (
    <div style={{ padding: '0' }}>
      <Card style={{ marginBottom: 16 }}>
        <Title level={3}>
          <ThunderboltOutlined /> 在线答题
        </Title>
        <Paragraph type="secondary">
          支持两种答题模式：ESP32红外遥控器答题 和 桌面客户端在线答题。
          选择适合您班级的答题方式。
        </Paragraph>
        
        <Space>
          <Tag icon={<ApiOutlined />} color="blue">ESP32红外遥控器</Tag>
          <Tag icon={<DesktopOutlined />} color="green">桌面客户端答题</Tag>
          <Tag icon={<TeamOutlined />} color="orange">支持抢答模式</Tag>
        </Space>
      </Card>

      <Collapse 
        activeKey={activeKey} 
        onChange={setActiveKey}
        style={{ background: '#fff' }}
      >
        {/* 红外遥控器答题模块 */}
        <Panel 
          header={
            <Space>
              <ApiOutlined style={{ color: '#1890ff' }} />
              <span style={{ fontWeight: 500 }}>红外遥控器答题</span>
              <Tag color="blue">ESP32</Tag>
            </Space>
          } 
          key="infrared"
          extra={<Tag>硬件设备</Tag>}
        >
          <div style={{ padding: '0' }}>
            <Card size="small" style={{ marginBottom: 16, background: '#f5f5f5' }}>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                使用ESP32红外遥控器接收学生的答题信号，适合有红外遥控器设备的班级。
                需要配合ESP32硬件设备使用。
              </Paragraph>
            </Card>
            
            {/* 这里可以选择显示题库管理或答题控制 */}
            <Collapse defaultActiveKey={['manager']}>
              <Panel header="题库管理" key="manager">
                <QuizManager />
              </Panel>
              <Panel header="答题控制" key="control">
                <QuizControl />
              </Panel>
            </Collapse>
          </div>
        </Panel>

        {/* 桌面客户端在线答题模块 */}
        <Panel 
          header={
            <Space>
              <DesktopOutlined style={{ color: '#52c41a' }} />
              <span style={{ fontWeight: 500 }}>桌面客户端在线答题</span>
              <Tag color="green">推荐</Tag>
            </Space>
          } 
          key="desktop"
          extra={<Tag color="success">无需硬件</Tag>}
        >
          <div style={{ padding: '0' }}>
            <Card size="small" style={{ marginBottom: 16, background: '#f6ffed' }}>
              <Paragraph type="secondary" style={{ margin: 0 }}>
                通过桌面客户端进行答题，学生输入操作码提交答案。支持单选、多选、判断、填空题型，
                支持普通答题、抢答、限时等多种模式。
              </Paragraph>
            </Card>
            
            <DesktopQuizManager />
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default OnlineQuiz;


